import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';

import { BehaviorSubject } from 'rxjs';
import { notificationRequest } from './Notification/model/NotificationRequest';
import { NotificationService } from './Notification/NotificationService';

export interface IMiyaUser {
	Id: number;
	UserName: string;
	FullName: string;
	UserType: number;
	UserTypeText: string;
	MemberOf: number[];
	ExternalId: number;
}
@Injectable()
export class MessagingService {
	currentMessage = new BehaviorSubject(null);
	constructor(private angularFireMessaging: AngularFireMessaging, private notificationService: NotificationService) {
		this.angularFireMessaging.onMessage;
		this.angularFireMessaging.onTokenRefresh;
		this.angularFireMessaging.messages.subscribe(message => {
			// Firebase'den yeni bir bildirim geldiğinde bu işlev çağrılır
			// message içinde bildirimle ilgili bilgilere erişebilirsiniz
			this.currentMessage.next(message);
		});
	}
	requestPermission() {
		this.angularFireMessaging.requestToken.subscribe(
			token => {
				if (token.length > 0 || token !== undefined) {
					const userStr = localStorage.getItem('User');
					const lngDistKod = localStorage.getItem('lngDistKod');
					let user: IMiyaUser = {
						Id: 0,
						UserName: '',
						FullName: '',
						UserType: 0,
						UserTypeText: '',
						MemberOf: [],
						ExternalId: 0
					};
					if (userStr) {
						user = JSON.parse(userStr) as IMiyaUser;
					}
					const request: notificationRequest = {
						LngDistKod: +lngDistKod,
						LngKullaniciKod: +user.ExternalId,
						TxtNotificationToken: token,
						LngKod: 0
					};
					this.notificationService.NotificationKaydet(request).subscribe(f => {
						console.log(f);
					});
				}
			},
			err => {
				console.error('Unable to get permission to notify.', err);
			}
		);
		this.angularFireMessaging.onTokenRefresh;
	}
	receiveMessage() {
		this.angularFireMessaging.messages.subscribe(payload => {
			console.log('new message received. ', payload);
			this.currentMessage.next(payload);
			new window.Notification('Yeni Mesaj', { body: 'Yeni Filo Siparişi Geldi.' });
		});
	}
}
